import { render, staticRenderFns } from "./small_title.vue?vue&type=template&id=54a8679c&scoped=true"
import script from "./small_title.vue?vue&type=script&lang=js"
export * from "./small_title.vue?vue&type=script&lang=js"
import style0 from "./small_title.vue?vue&type=style&index=0&id=54a8679c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8679c",
  null
  
)

export default component.exports